import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-white',
    borderColor: 'border-[#e2e8f0]',
    textColor: 'text-[#5c4033]',
    emoji: '📘',
    title: 'Introducción a la Ganadería y Producción Animal',
    subtitle: 'La base para entender todo lo demás',
    desc: 'Qué es la ganadería como actividad productiva · Principales especies animales de producción · Sistemas de producción extensivo e intensivo · Ciclo productivo y reproductivo animal · Conceptos básicos de manejo ganadero · Introducción a la sanidad y nutrición animal.',
    resuelve: 'El primer contacto con la ganadería puede ser el más transformador o el más aburrido. Este tomo convierte un tema técnico en algo comprensible, cercano y relevante para tus alumnos.',
    resultado: 'Tus alumnos entienden la producción animal como el eje central del sistema agropecuario y pueden explicarlo con lenguaje técnico correcto.',
    tags: ['PRODUCCIÓN', 'SISTEMAS', 'CICLO REPRODUCTIVO', 'ACTIVIDADES', 'EVALUACIÓN']
  }, {
    id: 2,
    lightColor: 'bg-white',
    borderColor: 'border-[#e2e8f0]',
    textColor: 'text-[#5c4033]',
    emoji: '📘',
    title: 'Agricultura, Suelos, Fertilización y Riego',
    subtitle: 'El tomo que más dudas genera y mejor resuelto está',
    desc: 'Tipos de suelos y su clasificación · Propiedades físicas, químicas y biológicas · Fertilización orgánica e inorgánica · Nutrientes esenciales para los cultivos · Sistemas de riego (goteo, aspersión, gravedad) · Manejo del agua en la producción agrícola · Labranza y conservación del suelo.',
    resuelve: 'Suelos y fertilización es el tema que más confusión genera y el que más preguntas técnicas acumula. Este tomo lo hace visual, ordenado y completamente enseñable.',
    resultado: 'Tus alumnos dejan de memorizar conceptos sin entenderlos y aprenden a razonar cómo y por qué el suelo es la base de toda producción agrícola.',
    tags: ['SUELOS', 'FERTILIZACIÓN', 'RIEGO', 'NUTRIENTES', 'ESQUEMAS']
  }, {
    id: 3,
    lightColor: 'bg-white',
    borderColor: 'border-[#e2e8f0]',
    textColor: 'text-[#5c4033]',
    emoji: '📘',
    title: 'Maquinaria Agrícola, Ganadería y Producción Sustentable',
    subtitle: 'Enseñá lo que van a usar en el campo real',
    desc: 'Tractores y implementos agrícolas · Sembradoras, cosechadoras y pulverizadoras · Mantenimiento básico de maquinaria · Ganadería intensiva y extensiva aplicada · Buenas prácticas agropecuarias · Producción sustentable y agroecología · Impacto ambiental de la actividad agropecuaria.',
    resuelve: 'Maquinaria y producción sustentable es donde más se traban los alumnos porque parece muy técnico y abstracto. Este tomo lo hace concreto, práctico y aplicable al contexto real.',
    resultado: 'Tus alumnos aprenden a identificar maquinaria, entender su función productiva y aplicar criterios de sustentabilidad reales en el campo.',
    tags: ['MAQUINARIA', 'TRACTORES', 'SUSTENTABILIDAD', 'BUENAS PRÁCTICAS', 'CASOS']
  }, {
    id: 6,
    lightColor: 'bg-[#f5f0e6]',
    borderColor: 'border-[#d4af37]',
    textColor: 'text-[#8b5a2b]',
    emoji: '📗',
    title: 'Producción Bovina',
    subtitle: 'El módulo más complejo. El mejor explicado.',
    desc: 'Razas bovinas y sus características productivas · Sistemas de cría, recría y engorde · Reproducción bovina (celo, inseminación, gestación) · Alimentación y nutrición del rodeo · Sanidad bovina y calendario de vacunación · Instalaciones ganaderas para bovinos · Indicadores productivos y económicos del rodeo.',
    resuelve: 'La producción bovina es el tema donde se define el perfil técnico de un egresado agropecuario. Es el contenido con más demanda en el mercado laboral del campo.',
    resultado: 'Tus alumnos comprenden el sistema bovino de adentro hacia afuera, con el nivel de profundidad que exige la realidad productiva del campo.',
    tags: ['RAZAS', 'REPRODUCCIÓN', 'SANIDAD', 'ALIMENTACIÓN', 'ESQUEMAS'],
    badge: '⭐ MÁS CONSULTADO'
  }];
  const libros = [{
    id: 1,
    title: 'Agricultura — Teoría completa'
  }, {
    id: 2,
    title: 'Ganadería + Anatomía y Fisiología Animal'
  }, {
    id: 3,
    title: 'Maquinaria Agrícola + Nutrición y Alimentación Animal'
  }, {
    id: 4,
    title: 'Agroindustria y Comercialización + Producción Animal'
  }, {
    id: 5,
    title: 'Gestión y Economía Agropecuaria + Sanidad Animal'
  }, {
    id: 6,
    title: 'Suelos y Fertilización — Teoría completa'
  }, {
    id: 7,
    title: 'Sistema de Riego + Producción Porcina'
  }, {
    id: 8,
    title: 'Tecnologías en el Agro + Producción Aviar'
  }, {
    id: 9,
    title: 'Instalaciones Ganaderas'
  }, {
    id: 10,
    title: 'Bienestar Animal'
  }, {
    id: 11,
    title: 'Producción Sustentable'
  }, {
    id: 12,
    title: 'Proyecto Productivo Final'
  }];
  const bonos = [{
    id: 1,
    title: 'Tomo 1',
    valor: '$15.000 ARS'
  }, {
    id: 2,
    title: 'Tomo 2',
    valor: '$12.000 ARS'
  }, {
    id: 3,
    title: 'Tomo 3',
    valor: '$10.000 ARS'
  }, {
    id: 4,
    title: 'Tomo 4',
    valor: '$9.000 ARS'
  }];
  return <section className="py-20 bg-[#fdfbf7]" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="text-center mb-16" data-id="element-160">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1a3622] text-[#fdfbf7] border border-[#2c4c3b] font-bold mb-6 text-[16px]" data-id="element-161">
            📘 LOS 3 TOMOS TÉCNICOS PRINCIPALES
          </div>
          <h2 className="md:text-5xl font-extrabold text-[#1a3622] mb-4 text-[24px]" data-id="element-162">
            Material completo para el aula
          </h2>
          <p className="text-[#4a3b32] font-medium text-[16px]" data-id="element-163">
            No es teoría copiada de un manual desactualizado. Es un sistema para
            que entres al aula con confianza.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-164">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#e2e8f0] bg-white overflow-hidden shadow-lg hover:shadow-xl hover:border-[#d4af37] transition-all flex flex-col h-full relative" data-id="element-165">
              {tomo.badge && <div className="absolute top-0 right-0 bg-[#d4af37] text-[#1a3622] font-bold text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-166">
                  {tomo.badge}
                </div>}
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-167">
                <div className="text-3xl" data-id="element-168">{tomo.emoji}</div>
                <div data-id="element-169">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-170">
                    {tomo.id === 6 ? 'Módulo' : 'Tomo'} {tomo.id}
                  </p>
                  <h3 className="font-bold text-[#1a3622] text-lg leading-tight" data-id="element-171">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-172">
                <p className="font-semibold text-[#8b5a2b] mb-3 pb-3 border-b border-[#e2e8f0]" data-id="element-173">
                  {tomo.subtitle}
                </p>
                <p className="text-[#4a3b32] text-sm leading-relaxed mb-4" data-id="element-174">
                  {tomo.desc}
                </p>
                <div className="bg-[#f5f0e6] p-3 rounded-lg mb-4 border border-[#e2e8f0]" data-id="element-175">
                  <p className="text-xs text-[#5c4033] mb-1" data-id="element-176">
                    <strong data-id="element-177">¿Qué resuelve en el aula?</strong>
                  </p>
                  <p className="text-sm text-[#4a3b32]" data-id="element-178">{tomo.resuelve}</p>
                </div>
                <div className="bg-[#1a3622]/5 p-3 rounded-lg mb-4 border border-[#1a3622]/10" data-id="element-179">
                  <p className="text-xs text-[#1a3622] mb-1" data-id="element-180">
                    <strong data-id="element-181">Resultado:</strong>
                  </p>
                  <p className="text-sm text-[#2c4c3b] font-medium" data-id="element-182">
                    {tomo.resultado}
                  </p>
                </div>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-183">
                  {tomo.tags.map((tag, j) => <span key={j} className="text-[10px] font-bold uppercase tracking-wider bg-[#fdfbf7] border border-[#d4af37] text-[#8b5a2b] px-2 py-1 rounded" data-id="element-184">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-12 border-t border-[#e2e8f0] pt-16" data-id="element-185">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1a3622] text-[#fdfbf7] border border-[#2c4c3b] font-bold mb-6 text-[16px]" data-id="element-186">
            📚 LOS 12 LIBROS COMPLEMENTARIOS
          </div>
          <h2 className="md:text-4xl font-extrabold text-[#1a3622] mb-4 text-[22px]" data-id="element-187">
            Incluidos sin costo extra
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto mb-16" data-id="element-188">
          {libros.map(libro => <div key={libro.id} className="bg-white border border-[#e2e8f0] p-4 rounded-xl flex items-center justify-between shadow-sm" data-id="element-189">
              <div className="flex items-center gap-3" data-id="element-190">
                <span className="text-[#d4af37] font-bold" data-id="element-191">
                  Libro {libro.id}
                </span>
                <span className="text-[#4a3b32] text-sm font-medium" data-id="element-192">
                  {libro.title}
                </span>
              </div>
              <span className="text-[#1a3622] text-xs font-bold bg-[#f5f0e6] px-2 py-1 rounded" data-id="element-193">
                ✅ INCLUIDO
              </span>
            </div>)}
        </div>

        <div className="bg-[#1a3622] rounded-3xl p-8 md:p-12 text-center max-w-4xl mx-auto mb-16 shadow-xl relative overflow-hidden" data-id="element-194">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#d4af37] opacity-10 rounded-full blur-3xl" data-id="element-195"></div>
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-196">
            🎮 SECCIÓN DE JUEGOS AGROPECUARIOS
          </h3>
          <p className="text-[#d4af37] font-bold mb-6" data-id="element-197">
            Incluida sin costo extra
          </p>
          <p className="text-[#fdfbf7] text-lg max-w-2xl mx-auto mb-8" data-id="element-198">
            Recursos lúdicos y didácticos diseñados para trabajar los contenidos
            agropecuarios de manera dinámica y participativa en el aula. Ideal
            para romper el hielo con temas técnicos complejos y mantener a tus
            alumnos comprometidos con el aprendizaje.
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-199">
            {['DINÁMICA DE AULA', 'PARTICIPACIÓN', 'APRENDIZAJE ACTIVO', 'LISTO PARA USAR'].map((tag, i) => <span key={i} className="bg-[#2c4c3b] text-[#fdfbf7] text-xs font-bold px-3 py-1 rounded-full border border-[#d4af37]/30" data-id="element-200">
                {tag}
              </span>)}
          </div>
        </div>

        <div className="text-center mb-12 border-t border-[#e2e8f0] pt-16" data-id="element-201">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#d4af37] text-[#1a3622] font-bold mb-6 text-[16px]" data-id="element-202">
            🎁 EL BONO EXTRA — 4 TOMOS ADICIONALES
          </div>
          <h2 className="md:text-4xl font-extrabold text-[#1a3622] mb-4 text-[22px]" data-id="element-203">
            Incluidos sin costo extra
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-204">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#e2e8f0] bg-white p-6 flex flex-col h-full relative overflow-hidden shadow-md" data-id="element-205">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#d4af37] to-[#f1d570]" data-id="element-206"></div>
              <h4 className="font-bold text-[#8b5a2b] mb-2 mt-2" data-id="element-207">
                BONO 0{bono.id}
              </h4>
              <h3 className="font-bold text-[#1a3622] text-lg mb-3" data-id="element-208">
                {bono.title}
              </h3>
              <p className="text-xs font-bold text-[#5c4033] mb-4 pb-3 border-b border-[#e2e8f0]" data-id="element-209">
                Valor real: <span className="line-through" data-id="element-210">{bono.valor}</span> →{' '}
                <span className="text-[#1a3622]" data-id="element-211">GRATIS</span>
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gradient-to-br from-[#1a3622] to-[#2c4c3b] rounded-2xl p-6 md:p-8 border border-[#d4af37] text-center shadow-2xl" data-id="element-212">
          <p className="text-[#fdfbf7] font-medium mb-2" data-id="element-213">
            Valor total del Bono Extra: $46.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-214">
            Tu precio hoy: <span className="text-[#d4af37]" data-id="element-215">🎁 GRATIS</span>
          </p>
          <p className="text-[#cbd5e1] text-sm" data-id="element-216">
            Solo incluidos en esta oferta de lanzamiento.
          </p>
        </motion.div>
      </div>
    </section>;
}